import type { EventType } from "app/types/eventType";
import {
  competitionListTimeEnum,
  EventStatus,
  MarketTypes,
  RunnerTypes,
} from "app/utils/const";
import React from "react";
import AsianOddsEmpty from "../../../AsianOdds/AsianOddsEmpty";
import "./AsianEventMarket1x2.scss";
import { CreateRunnerElements } from "./components/CreateRunnerElements/CreateRunnerElements";
import NoRunnersElement from "./components/NoRunnersElement/NoRunnersElement";
import PlaceholderOddsElements from "./components/PlaceholderOddsElements/PlaceholderOddsElements";
import { runnersDict } from "./helpers/runnersDictHelper";

type Props = {
  event: EventType;
  addBetSlip: (...args: Array<any>) => any;
  market: Record<string, any>;
  highestNumberOfMarkets: number;
  line: string;
  row?: boolean; // When 1x2 is selected from left hand panel(sport selection panel), show as a row instead of a column
};

export const AsianEvent1x2 = (props: Props): React.JSX.Element => {
  const { market, addBetSlip, event, highestNumberOfMarkets, line, row } =
    props;
  const runners = market.runners;
  // Show the empty market placeholder
  if (!runners) {
    return (
      <div className="asian-marketType-outer-container__onextwo">
        <NoRunnersElement line={line} />
        <PlaceholderOddsElements count={highestNumberOfMarkets} />
      </div>
    );
  }

  const renderRunners = (runnersOrder: string[]) => (
    <>{runnersOrder.map(runner => runnersDict[runner] || <AsianOddsEmpty />)}</>
  );

  const getRunnersOrder = () => {
    switch (market.type) {
      case MarketTypes.ONE_X_TWO:
        return row
          ? [RunnerTypes.HOME, RunnerTypes.NA, RunnerTypes.AWAY]
          : [RunnerTypes.HOME, RunnerTypes.AWAY, RunnerTypes.NA];
      case MarketTypes.MONEY_LINE:
      case MarketTypes.DRAW_NO_BET:
        return event.showHomePlayerAsFirst
          ? [RunnerTypes.HOME, RunnerTypes.AWAY]
          : [RunnerTypes.AWAY, RunnerTypes.HOME];
      default:
        return [];
    }
  };

  const displayRunners = () => {
    CreateRunnerElements({
      runners,
      event,
      addBetSlip,
      market,
      props: { event, addBetSlip, market, highestNumberOfMarkets, line, row },
    });

    return renderRunners(getRunnersOrder());
  };

  //  css classes
  const isAllView = line === competitionListTimeEnum.ALL;
  const asianMarketTypeContainerClasses = `asian-marketType-container__onextwo  ${
    isAllView ? "all-view" : ""
  } ${row ? "asian-marketType-container__onextwo--row" : ""}`;
  //

  return (
    <div className="asian-marketType-outer-container__onextwo">
      <div className={asianMarketTypeContainerClasses}>
        {(market.status === EventStatus.OPEN ||
          market.status === EventStatus.SUSPENDED) &&
          runners?.length > 0 &&
          displayRunners()}

        {(market.status === EventStatus.OPEN ||
          market.status === EventStatus.SUSPENDED) &&
          (!runners || runners?.length === 0) && (
            <NoRunnersElement line={line} />
          )}
      </div>
      <PlaceholderOddsElements count={highestNumberOfMarkets} />
    </div>
  );
};
